<template>
  <div>
    <!-- Navbar-->
    <Nav />
    <!-- Sidebar menu-->
    <div class="app-sidebar__overlay" data-toggle="sidebar"></div>
    <Side />
    <main class="app-content">
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
import $ from 'jquery';
import Nav from './layouts/Nav.vue';
import Side from './layouts/Side.vue';

export default {
  components: { Nav, Side },
  mounted() {
    var treeviewMenu = $('.app-menu');

    // Toggle Sidebar
    $('[data-toggle="sidebar"]').click(function (event) {
      event.preventDefault();
      $('.app').toggleClass('sidenav-toggled');
    });

    // Activate sidebar treeview toggle
    $("[data-toggle='treeview']").click(function (event) {
      event.preventDefault();
      if (!$(this).parent().hasClass('is-expanded')) {
        treeviewMenu.find("[data-toggle='treeview']").parent().removeClass('is-expanded');
      }
      $(this).parent().toggleClass('is-expanded');
    });
  },
}
</script>

<style></style>